import * as React from 'react';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { SessionReservationEvaluationPaneState } from './states/SessionReservationEvaluationPaneState';

type Props = {
  match: {
    url: string;
    params: {
      sessionId: string;
    };
  };
};

export const SessionEvaluationPane = observer(
  class SessionEvaluationPane extends React.Component<Props> {
    paneState = new SessionReservationEvaluationPaneState();

    constructor(props: Props) {
      super(props);

      makeObservable(this, {
        paneState: observable,
      });
    }

    componentDidMount(): void {
      this.init();
    }

    componentDidUpdate(prevProps: Readonly<Props>): void {
      if (this.props.match.params.sessionId !== prevProps.match.params.sessionId) {
        this.init();
      }
    }

    init() {
      this.paneState.init(Number(this.props.match.params.sessionId));
    }

    render() {
      return null;
    }
  }
);
